/**
 * `/settings/agents/*` — #44573 (largest single hole in the rollover).
 *
 * 22 page paths that had no Vite route. Sources are the corresponding
 * `excellent/app/settings/agents/<name>/page.tsx` files; live Next pages are
 * UNTOUCHED (D6). Bodies live under `client/shared/settings/agents/pages.tsx`
 * and self-fetch through contracted GETs / existing list ops.
 *
 * `settingsReposRoute` and `settingsAutoVerifyRoute` already redirect here —
 * porting repos + auto-verify first unblocks those live broken targets.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import {
  ReposAgentsPage,
  AutoVerifyAgentsPage,
  AuditsAgentsPage,
  AutopilotAgentsPage,
  ClisAgentsPage,
  ConsentAgentsPage,
  ContextAgentsPage,
  CopilotAgentsPage,
  CredentialsAgentsPage,
  DatabaseAgentsPage,
  FleetAgentsPage,
  InboundAgentsPage,
  IntegrateAgentsPage,
  LearningAgentsPage,
  MirrorAgentsPage,
  MonitorAgentsPage,
  NotifyAgentsPage,
  OptimizationAgentsPage,
  ResidencyAgentsPage,
  TelemetryAgentsPage,
  VerdictsAgentsPage,
} from "../shared/settings/agents/pages";

export const settingsAgentsReposRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/repos",
  component: ReposAgentsPage,
});

export const settingsAgentsAutoVerifyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/auto-verify",
  component: AutoVerifyAgentsPage,
});

export const settingsAgentsAuditsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/audits",
  component: AuditsAgentsPage,
});

export const settingsAgentsAutopilotRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/autopilot",
  component: AutopilotAgentsPage,
});

export const settingsAgentsClisRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/clis",
  component: ClisAgentsPage,
});

export const settingsAgentsConsentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/consent",
  component: ConsentAgentsPage,
});

export const settingsAgentsContextRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/context",
  component: ContextAgentsPage,
});

export const settingsAgentsCopilotRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/copilot",
  component: CopilotAgentsPage,
});

export const settingsAgentsCredentialsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/credentials",
  component: CredentialsAgentsPage,
});

export const settingsAgentsDatabaseRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/database",
  component: DatabaseAgentsPage,
});

export const settingsAgentsFleetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/fleet",
  component: FleetAgentsPage,
});

export const settingsAgentsInboundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/inbound",
  component: InboundAgentsPage,
});

export const settingsAgentsIntegrateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/integrate",
  component: IntegrateAgentsPage,
});

export const settingsAgentsLearningRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/learning",
  component: LearningAgentsPage,
});

export const settingsAgentsMirrorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/mirror",
  component: MirrorAgentsPage,
});

export const settingsAgentsResidencyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/models/residency",
  component: ResidencyAgentsPage,
});

export const settingsAgentsMonitorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/monitor",
  component: MonitorAgentsPage,
});

export const settingsAgentsNotifyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/notify",
  component: NotifyAgentsPage,
});

export const settingsAgentsOptimizationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/optimization",
  component: OptimizationAgentsPage,
});

export const settingsAgentsTelemetryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/telemetry",
  component: TelemetryAgentsPage,
});

export const settingsAgentsVerdictsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/verdicts",
  component: VerdictsAgentsPage,
});
